import { FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },

  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    cell:'navigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SourceId',
    field: FIELDS.SOURCE_ID,
    title: ' Source Id',
    label: 'SourceId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SourceName',
    field: FIELDS.SOURCE_NAME,
    title: ' Source Name',
    label: 'SourceName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReferenceId',
    field: FIELDS.REFERENCE_ID,
    title: ' Reference Id',
    label: 'ReferenceId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountId',
    field: FIELDS.ACCOUNT_ID,
    title: ' Account Id',
    label: 'AccountId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'AccountName',
    field: FIELDS.ACCOUNT_NAME,
    title: ' Account Name',
    label: 'AccountName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ExpenseDate',
    field: FIELDS.EXPENSE_DATE,
    title: ' Expense Date',
    label: 'ExpenseDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
